import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMegaphoneRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.438 2.75a.56.56 0 0 0-.563.563v.316L3.125 6.37v-.059a.56.56 0 0 0-.562-.562.56.56 0 0 0-.563.563v3.375c0 .311.25.562.563.562a.56.56 0 0 0 .562-.562v-.06l2.023.57a2.25 2.25 0 1 0 4.315 1.212l3.412.961v.316c0 .312.25.563.563.563a.56.56 0 0 0 .562-.562V3.313a.56.56 0 0 0-.562-.563m-.563 8.452-9.75-2.743v-.92l9.75-2.743zm-4.505-.099A1.126 1.126 0 0 1 6.125 11c0-.178.042-.347.115-.495l2.13.6z" })
});
export default SvgMegaphoneRegularIcon;
